import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import {EmapsError} from '../../shared/models/interfaces/emapsError.interface';


@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  constructor(
  ) { }


  public catchBadResponse(response: HttpErrorResponse): Observable<any> {
    if (response.error) {
      response.error.status = response.status;
      response.error.statusText = response.statusText;
      return throwError(response.error);
    } else {
      return throwError(response);
    }
  }
}
